import swal from "sweetalert";
import { toast } from "react-toastify";

import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import bookclosurecss from "./../../css/bookclosure.module.css";
import Modal from "./../../elements/Modal";
import Dropdown from "./../../elements/Dropdown";
import { Button } from "./../../elements/Button";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import { useEffect, useState } from "react";
import {
  getAllCOA,
  mapCOAtoTBApiHandler,
} from "../../../Bookclosure/Services/ApiHandler";
import { useHistory, useLocation, useParams } from "react-router";

const SelectCOAModal = ({
  setCOAModal,
  companyId,
  selectedConnection,
  bookClosureId,
  handleAddTbModals,
  getBookClosureData,
  workspaceId,
  erpTBId,
}) => {
  const history = useHistory();
  const [coaList, setCoaList] = useState([]);
  const [selectedCoa, setSelectedCoa] = useState(null);

  useEffect(() => {
    GetAllCoa();
    console.log("coaList", coaList);
  }, []);

  const GetAllCoa = () => {
    getAllCOA(companyId)
      .then((response) => {
        const transformedData = [
          { value: "", label: "" },
          ...response.data.bookClosureCOAList.map((item) => ({
            value: item._id,
            label: item.name,
          })),
        ];
        setCoaList(transformedData);
      })
      .catch((error) => {
        swal(
          "Error",
          `Get all COA failed: ${error.response?.data?.error}`,
          "error"
        );
      });
  };

  const mapCOAtoTB = () => {
    if (selectedCoa) {
      const payload = {
        trialBalanceID: erpTBId,
        coaID: selectedCoa,
      };
      mapCOAtoTBApiHandler(payload)
        .then((response) => {
          window.location.href = `/bookclosure/${workspaceId}`;
          toast.success("COA Added Successfully.");
          handleAddTbModals("close");
        })
        .catch((error) => {
          swal(
            "Error",
            error?.response?.data?.error || "Create COA failed",
            "error"
          );
          handleAddTbModals("close");
        });
    }else{
      handleAddTbModals("close");
    }
  };
  return (
    <Modal
      title="Select COA"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <CloseIcon
          onClick={() => {
            setCOAModal(false);
          }}
          className="clickable"
        />
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setCOAModal(false);
              window.location.href = `/bookclosure/${workspaceId}`;
            }}
            label="Cancel"
          />
          <Button
            btnColor={buttoncss.primary}
            label="Proceed"
            onClick={() => {
              mapCOAtoTB();
            }}
          />
        </>
      }
    >
      <div className={commoncss.pd1530}>
        {coaList.length > 0 && (
          <Dropdown
            label="Select COA"
            options={coaList}
            onSelect={(opt) => setSelectedCoa(opt.value)}
            placeHolder={"Select COA"}
          />
        )}
      </div>
    </Modal>
  );
};

export default SelectCOAModal;
